import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HotRecommend() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩漫画</p>
        </div>
        <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer">
          更多 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {featuredComics.map(comic => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}

function ComicCard({ comic }: { comic: typeof featuredComics[0] }) {
  return (
    <Link to={`/comic/${comic.id}`} className="group cursor-pointer">
      <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
        <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105" loading="lazy" />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
            comic.status === '连载中' ? 'bg-primary-500 text-white' : 'bg-secondary-500 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <span className="text-white text-xs whitespace-nowrap">更新至 {comic.latestChapter}</span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">{comic.title}</h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-accent-500 font-medium whitespace-nowrap">
          <i className="ri-star-fill w-3 h-3 inline-flex items-center justify-center"></i> {comic.rating}
        </span>
        <span className="text-xs text-foreground-400">{comic.views}</span>
      </div>
    </Link>
  );
}